import config from '__api/config';
import { BlueBtn } from '__components/BlueBtn';
import Mask from '__components/Mask';
import { openUrl } from '__utils/openUrl';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

interface Props {
  onPress?: Function;
}

interface State {
  isShow: boolean;
  money: string;
}

export class DrawCashPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
      money: '',
    };
  }

  show = (money: string) => {
    this.setState({ isShow: true, money: money });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress } = this.props;
    const { isShow, money } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0.02 }}
                end={{ x: 0, y: 0.31 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <View style={{ marginTop: rpx(36) }}>
                  <Text style={styles.text1}>
                    {money}元<Text style={styles.text3}> 已提现至我的钱包</Text>
                  </Text>
                </View>
                <Spacer size={rpx(30)} />
                <EmTouchableOpacity
                  activeOpacity={0.9}
                  style={styles.toWatch}
                  onPress={() => {
                    openUrl(config.redPacketUrl);
                  }}
                >
                  <Image
                    style={styles.toWatch}
                    source={require('../../images/invite/toWatch.png')}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>
                <Spacer size={rpx(30)} />
              </LinearGradient>
              <EmTouchableOpacity
                onPress={() => {
                  onPress && onPress();
                }}
                style={styles.closeImg}
              >
                <Image
                  style={styles.closeImg}
                  source={require('../../images/invite/closeBtn.png')}
                  resizeMode={'stretch'}
                />
              </EmTouchableOpacity>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
  },
  toWatch: {
    width: rpx(211),
    height: rpx(41),
  },
  text1: {
    fontSize: rpx(15),
    color: '#FF2233',
  },
  text3: {
    fontSize: rpx(15),
    color: '#333333',
  },
  closeImg: {
    marginTop: rpx(20),
    width: rpx(56),
    height: rpx(41),
  },
  taskBtn: {
    width: rpx(250),
    height: rpx(40),
    borderRadius: rpx(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
});
